import { downloadBffFile } from "../../common/download/downloadBffFile";

export const downloadFilteredIfrsReport = (encodedQ: string) =>
  downloadBffFile(`/api/contracts/ifrs-report/filtered?q=${encodeURIComponent(encodedQ)}`, ifrsReportFileName(new Date()));

export const downloadSelectedContractsIfrsReport = (contractIds: string[]) =>
  downloadBffFile(`/api/contracts/ifrs-report?contractIds=${contractIds.join(",")}`, ifrsReportFileName(new Date()));

export const downloadContractIfrsReport = (contract: { id: string; title: string }) =>
  downloadBffFile(`/api/contracts/${contract.id}/ifrs-report`, contractIfrsReportFileName(contract.title));

// The BFF sends the same names in Content-Disposition, but its CORS policy exposes no headers, so a cross-origin fetch cannot read them.
export const ifrsReportFileName = (now: Date): string => `IFRS16-rapport-${now.toLocaleDateString("sv-SE")}.xlsx`;

export const contractIfrsReportFileName = (title: string): string =>
  `${Array.from(title).filter((c) => /[\p{L}\p{N}-]/u.test(c)).join("") || "IFRS16-rapport"}.xlsx`;
